// extracted by mini-css-extract-plugin
module.exports = {"incoming":"ChatMessage-module__incoming___1uCeY","outgoing":"ChatMessage-module__outgoing___2gegk","incomingImage":"ChatMessage-module__incomingImage___3Wtq0"};